/* ============================================================
   VIRA — Shopify theme JS
   Works inside any Online Store 2.0 theme. No dependencies.
   ============================================================ */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Render star icons from [data-stars] ---------- */
  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.8 6.1 20.5l1.2-6.5L2.5 9.4l6.6-.9z"/></svg>';
  var STAR_O = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.8 6.1 20.5l1.2-6.5L2.5 9.4l6.6-.9z"/></svg>';
  $$('[data-stars]').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-stars'), 10) || 5, out = '';
    for (var i = 0; i < 5; i++) out += i < n ? STAR : STAR_O;
    el.innerHTML = out;
  });

  /* ---------- Gallery tabs (stacked media + thumbnail buttons) ---------- */
  $$('[data-gallery]').forEach(function (gal) {
    var root = gal.closest('.gallery') || gal.parentNode || gal;
    var thumbs = $$('.thumb', root);
    var views = $$('.gview', gal);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-i'), 10);
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        views.forEach(function (v, vi) { v.classList.toggle('active', vi === i); });
      });
    });
  });

  /* ---------- Accordions (what's inside + FAQ) ---------- */
  $$('.acc').forEach(function (acc) {
    $$('.acc-item', acc).forEach(function (item) {
      var q = $('.acc-q', item), a = $('.acc-a', item);
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        $$('.acc-item', acc).forEach(function (o) {
          o.classList.remove('open');
          var oa = $('.acc-a', o); if (oa) oa.style.maxHeight = null;
        });
        if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  });

  /* ---------- Review filters ---------- */
  $$('[data-review-filters]').forEach(function (bar) {
    var grid = document.getElementById(bar.getAttribute('data-target'));
    if (!grid) return;
    $$('button', bar).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('button', bar).forEach(function (x) { x.classList.remove('active'); });
        btn.classList.add('active');
        var f = btn.getAttribute('data-f');
        $$('.ugc-card', grid).forEach(function (card) {
          var tags = card.getAttribute('data-tags') || '';
          card.style.display = (f === 'all' || tags.indexOf(f) > -1) ? '' : 'none';
        });
      });
    });
  });

  /* ---------- Announcement rotation ---------- */
  (function () {
    var track = $('#announceTrack');
    if (!track) return;
    var msgs = $$('[data-announce-msg]', track).map(function (m) { return m.innerHTML; });
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % msgs.length;
      track.style.opacity = 0;
      setTimeout(function () { track.innerHTML = msgs[i]; track.style.opacity = 1; }, 400);
    }, 4500);
  })();

  /* ---------- Product form: variants, qty, price, sticky bar, AJAX cart ---------- */
  var form = $('#viraProductForm');
  if (!form) return;

  var idInput   = $('input[name="id"]', form);
  var qtyInput  = $('#qtyInput', form);
  var addPrice  = $('#addPrice');
  var stickyPrice = $('#stickyPrice');
  var stickyName  = $('#stickyBundleName');
  var sellingPlanInput = $('input[name="selling_plan"]', form);
  var subscribe = false;

  function currentBundle() { return $('.bundle.selected', form); }

  function syncPrice() {
    var b = currentBundle();
    if (!b) return;
    var oneTime = b.getAttribute('data-price');           // money string e.g. "$147.00"
    var subPrice = b.getAttribute('data-sub-price') || oneTime;
    var label = (b.getAttribute('data-name') || '') + (subscribe ? ' · Subscription' : '');
    var price = subscribe ? subPrice : oneTime;
    if (addPrice)    addPrice.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (stickyName)  stickyName.textContent = label;
    // variant id
    if (idInput) idInput.value = b.getAttribute('data-variant-id');
    // selling plan id (subscription)
    if (sellingPlanInput) sellingPlanInput.value = subscribe ? (b.getAttribute('data-selling-plan') || '') : '';
  }

  // Bundle selection
  $$('.bundle', form).forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      $$('.bundle', form).forEach(function (x) { x.classList.remove('selected'); });
      b.classList.add('selected');
      syncPrice();
    });
  });

  // Subscribe / one-time toggle
  $$('#purchaseToggle button', form).forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('#purchaseToggle button', form).forEach(function (x) { x.classList.remove('active'); });
      btn.classList.add('active');
      subscribe = btn.getAttribute('data-type') === 'subscribe';
      syncPrice();
    });
  });

  // Quantity
  if (qtyInput) {
    $$('[data-qty]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10));
        qtyInput.value = v;
      });
    });
    qtyInput.addEventListener('input', function () {
      var v = parseInt(qtyInput.value.replace(/\D/g, ''), 10);
      qtyInput.value = (isNaN(v) || v < 1) ? 1 : v;
    });
  }

  syncPrice();

  // Adds the current selection, then goes straight to checkout.
  var busy = false;
  function addToCart(sourceBtn) {
    if (busy) return;
    busy = true;
    var btn = sourceBtn || $('#addToCart');
    var orig = btn ? btn.innerHTML : '';
    if (btn) btn.innerHTML = 'Adding…';
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (btn) btn.innerHTML = 'Redirecting…';
        window.location.href = '/checkout';
      })
      .catch(function () {
        busy = false;
        if (btn) btn.innerHTML = orig;
        form.submit();
      });
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); addToCart($('#addToCart')); });

  var stickyAdd = $('#stickyAdd');
  if (stickyAdd) {
    stickyAdd.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(stickyAdd);
    });
  }

  /* ---------- Sticky bar reveal ---------- */
  var sticky = $('#stickyBar');
  var hero = $('[data-buybox]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '-120px 0px 0px 0px' });
    io.observe(hero);
  }
})();
